import React from 'react';
import './TrustedBrands.css';

const TrustedBrands = () => {
  const brands = [
    { name: 'VOLVO', logo: '/Photos/Logos/Volvo logo.png' },
    { name: 'BHARAT BENZ', logo: '/Photos/Logos/Bharat benz logo.png' },
    { name: 'EICHER', logo: '/Photos/Logos/Eicher logo.png' },
    { name: 'MAN', logo: '/Photos/Logos/Man logo.png' }
  ];

  return (
    <section className="trusted-brands-section">
      <div className="brands-container">
        <h2 className="brands-title">Brands We Specialize In</h2>
        <div className="brands-divider-top"></div>
        <div className="brands-logos">
          {brands.map((brand, index) => (
            <div key={index} className="brand-logo">
              <div className="brand-icon-container">
                <img 
                  src={brand.logo} 
                  alt={brand.name} 
                  className="brand-icon"
                />
              </div>
              <span className="brand-name">{brand.name}</span>
            </div>
          ))}
        </div>
        <div className="brands-divider-bottom"></div>
      </div>
    </section>
  );
};

export default TrustedBrands;

